import { queryOptions } from '@tanstack/react-query';
import { apiFetch } from '../api-client';

export interface ImpersonateSession {
  id: string;
  createdAt: string;
  operatorName: string;
  tenantName: string;
  reason: string;
  ticketRef: string | null;
  durationMs: number | null;
  endedAt: string | null;
}

export interface ImpersonateSessionsResponse {
  sessions: ImpersonateSession[];
}

async function fetchRecentSessions(): Promise<ImpersonateSessionsResponse> {
  const res = await apiFetch('/api/console/impersonation/sessions?limit=10');
  if (!res.ok) throw new Error('Failed to load sessions');
  return res.json();
}

export function recentSessionsQueryOptions() {
  return queryOptions<ImpersonateSessionsResponse>({
    queryKey: ['impersonation-sessions'],
    queryFn: fetchRecentSessions,
  });
}
